import { totals, uniqueTrussTypes } from '../Volumetrics';

export const SortableColumns = [
	'jobTypeName',
	'requestTypeName',
	'customerName',
	'contactName',
	'creatorName',
	'projectName',
	'countryName',
	'organizationName',
	'clientName',
	'clientTypeName',
	'jobRef',
	'jobName',
	'transactionRef',
	'transactionName',

	// NEW: the report "barrel" — current drawing status.
	'drawingStatus',

	'transactionCreatedAt',
	'transactionAllocatedAt',
	'transactionTargetAt',
	'transactionDesignCompletedFirstAt',
	'transactionDesignCompletedAt',
	'transactionDesignReworkCompletedAt',
	'transactionDueAt',
	'transactionFirstCompletedOverdueByHours',
	'transactionOverdueByHours',
	'transactionTargetFirstCompletedOverdueByHours',
	'transactionTargetOverdueByHours',
	'transactionLeadTimeMinutes',
	'transactionPendingFeedbackMinutes',
	'transactionDifficulty',
	'transactionRequirementsJoined',
	'transactionAncillaryItemsJoined',
	'transactionSubAncillaryItemsJoined',

	...totals,
	...uniqueTrussTypes,

	'transactionOwnerName',
	'aiFeedbackDidUseFPSMatch',
	'aiFeedbackFPSJobId',
	'aiFeedbackDidUseAIFrame',
	'aiFeedbackDidModifyAIFrame',
	'aiFeedbackNoAIFrameReasonCode',
	// Per-stage time — ACTIVE + TOTAL only (the v2 MV has no Pause variant).
	'designInProgressActive',
	'designInProgressTotal',
	'reworkInProgressActive',
	'reworkInProgressTotal',
	'finaliseActive',
	'finaliseTotal',
	'ownerActive',
	'ownerTotal',
	'teamLeaderReviewInProgressActive',
	'teamLeaderReviewInProgressTotal',
	'qualityAssuranceInProgressActive',
	'qualityAssuranceInProgressTotal',

	// MTO invoice grand total — sortable (real precomputed `mto_invoice` MV column).
	'mtoInvoice',
	// When the MTO invoice was last genuinely recomputed — sortable date column
	// (real precomputed `mto_invoice_last_updated_at` MV column).
	'mtoInvoiceLastUpdatedAt',
] as const;

export const VisibleColumns = [...SortableColumns] as const;
